<div class="price-editor-form">
  <app-button-toggle-group
    [control]="priceTypeControl"
    [values]="availableTypes"
    bindLabel="name"
    [isRequired]="true"
    [isError]="priceTypeControl.invalid && priceTypeControl.touched"
    (focusout)="priceTypeControl.markAsTouched()"
    (onValueChange)="onChangeType($event)"
  />
  <ng-container *ngTemplateOutlet="changePriceValueTemplate" />
</div>

<ng-template #changePriceValueTemplate>
  @if (priceTypeControl.value === OlxPriceType.PRICE) {
    <div class="price-editor-form-value-container">
      <div class="price-editor-form-value">
        <app-text-field
          class="w-100 overflow-hidden"
          type="v2"
          mask="separator.2"
          customClass="text-field-height-40"
          [formControl]="priceForm.controls.value"
          (onValueChange)="onPriceValueChange()"
        />
        <app-dropdown
          [items]="currencyTypes"
          bindValue="value"
          [closeOnSelect]="true"
          [formControl]="priceForm.controls.currency"
        />
      </div>
      <app-toggle [formControl]="priceForm.controls.negotiable" labelPosition="after">
        {{ 'negotiable' | translate }}
      </app-toggle>
    </div>
  }
</ng-template>
